// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications {
  width: 360px;
  max-width: 90vw;
  max-height: 400px;
  overflow: hidden;
  overflow-y: auto;
  padding: 0;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
}

.notifications .dropdown-header {
  background-color: #f6f9ff;
  padding: 15px;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  font-size: 14px;
  color: #012970;
  position: sticky;
  top: 0;
  z-index: 2;
}

.notifications .dropdown-header a {
  text-decoration: none;
}

.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 15px;
  transition: background-color 0.3s ease;
}

.notification-item:hover {
  background-color: #f6f9ff;
}

.notification-item.unread {
  background: #f5f8ff;
}

.notification-item i {
  font-size: 24px;
  margin-right: 0;
  flex-shrink: 0;
  margin-top: 5px;
}

.notification-item div {
  flex: 1 1;
  min-width: 0;
}

.notification-item h4 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #012970;
}

.notification-item p {
  font-size: 13px;
  margin-bottom: 3px;
  color: #919191;
  word-break: break-word;
}

.notification-item p:last-child {
  font-size: 12px;
  color: #aaa;
}

.dropdown-footer {
  background-color: #f6f9ff;
  padding: 10px;
  text-align: center;
  border-top: 1px solid #eee;
  position: sticky;
  bottom: 0;
  z-index: 2;
}

.dropdown-footer button {
  color: #012970;
  font-size: 14px;
  text-decoration: none;
  padding: 5px;
}

.dropdown-footer button:hover {
  text-decoration: underline;
}

.badge-number {
  position: absolute;
  top: 5px;
  right: 8px;
  font-size: 10px;
  padding: 3px 6px;
  border-radius: 50%;
}

.nav-icon {
  position: relative;
  font-size: 20px;
}

.notifications-page-scroll {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.notification-dot {
  width: 8px;
  height: 8px;
  min-width: 8px;
  border-radius: 50%;
  background: #0d6efd;
}

.notifications::-webkit-scrollbar,
.notifications-page-scroll::-webkit-scrollbar {
  width: 6px;
}

.notifications::-webkit-scrollbar-track,
.notifications-page-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.notifications::-webkit-scrollbar-thumb,
.notifications-page-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.notifications::-webkit-scrollbar-thumb:hover,
.notifications-page-scroll::-webkit-scrollbar-thumb:hover {
  background: #999;
}`, "",{"version":3,"sources":["webpack://./src/Components/Notification/NotificationDropdown.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB","sourcesContent":[".notifications {\n  width: 360px;\n  max-width: 90vw;\n  max-height: 400px;\n  overflow: hidden;\n  overflow-y: auto;\n  padding: 0;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);\n  border-radius: 6px;\n}\n\n.notifications .dropdown-header {\n  background-color: #f6f9ff;\n  padding: 15px;\n  border-bottom: 1px solid #eee;\n  font-weight: 600;\n  font-size: 14px;\n  color: #012970;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.notifications .dropdown-header a {\n  text-decoration: none;\n}\n\n.notification-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 15px;\n  transition: background-color 0.3s ease;\n}\n\n.notification-item:hover {\n  background-color: #f6f9ff;\n}\n\n.notification-item.unread {\n  background: #f5f8ff;\n}\n\n.notification-item i {\n  font-size: 24px;\n  margin-right: 0;\n  flex-shrink: 0;\n  margin-top: 5px;\n}\n\n.notification-item div {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-item h4 {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 5px;\n  color: #012970;\n}\n\n.notification-item p {\n  font-size: 13px;\n  margin-bottom: 3px;\n  color: #919191;\n  word-break: break-word;\n}\n\n.notification-item p:last-child {\n  font-size: 12px;\n  color: #aaa;\n}\n\n.dropdown-footer {\n  background-color: #f6f9ff;\n  padding: 10px;\n  text-align: center;\n  border-top: 1px solid #eee;\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n}\n\n.dropdown-footer button {\n  color: #012970;\n  font-size: 14px;\n  text-decoration: none;\n  padding: 5px;\n}\n\n.dropdown-footer button:hover {\n  text-decoration: underline;\n}\n\n.badge-number {\n  position: absolute;\n  top: 5px;\n  right: 8px;\n  font-size: 10px;\n  padding: 3px 6px;\n  border-radius: 50%;\n}\n\n.nav-icon {\n  position: relative;\n  font-size: 20px;\n}\n\n.notifications-page-scroll {\n  max-height: 70vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.notification-dot {\n  width: 8px;\n  height: 8px;\n  min-width: 8px;\n  border-radius: 50%;\n  background: #0d6efd;\n}\n\n.notifications::-webkit-scrollbar,\n.notifications-page-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.notifications::-webkit-scrollbar-track,\n.notifications-page-scroll::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.notifications::-webkit-scrollbar-thumb,\n.notifications-page-scroll::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 10px;\n}\n\n.notifications::-webkit-scrollbar-thumb:hover,\n.notifications-page-scroll::-webkit-scrollbar-thumb:hover {\n  background: #999;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
